import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  TextField, Button, CircularProgress
} from '@mui/material';

const SaveChatSessionDialog = ({ open, onClose, onSave, session, isSaving = false }) => {
  const [name, setName] = useState('');
  const [nameError, setNameError] = useState('');

  useEffect(() => {
    if (session) {
      setName(session.name || '');
    } else {
      setName('');
    }
    setNameError('');
  }, [session, open]);

  const handleSave = () => {
    if (!name.trim()) {
      setNameError('Name cannot be empty.');
      return;
    }
    setNameError('');
    onSave(name);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
    if (nameError) setNameError('');
  }

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="save-session-dialog-title" fullWidth maxWidth="xs">
      <DialogTitle id="save-session-dialog-title">
        {session?.save ? 'Edit Session Name' : 'Save Session'}
      </DialogTitle>
      <DialogContent>
        <DialogContentText sx={{mb: 1}}>
          {session?.save ? 'Enter a new name for this session.' : 'Please enter a name for this session to save it.'}
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="session-name"
          label="Session Name"
          type="text"
          fullWidth
          variant="outlined"
          value={name}
          onChange={handleNameChange}
          error={!!nameError}
          helperText={nameError}
          disabled={isSaving}
        />
      </DialogContent>
      <DialogActions sx={{p: '16px 24px'}}>
        <Button onClick={onClose} disabled={isSaving}>Cancel</Button>
        <Button onClick={handleSave} disabled={isSaving || !!nameError || !name.trim()} variant="contained">
          {isSaving ? <CircularProgress size={24} /> : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SaveChatSessionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  session: PropTypes.object, 
  isSaving: PropTypes.bool,
};

export default SaveChatSessionDialog;